/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Auto-save cart note in drawer
  document.addEventListener('DOMContentLoaded', function() {
    const cartNoteField = document.querySelector('#note');
    
    if (cartNoteField) {
      let saveTimeout;
      
      cartNoteField.addEventListener('input', function() {
        // Clear previous timeout
        clearTimeout(saveTimeout);
        
        // Wait 1 second after user stops typing
        saveTimeout = setTimeout(function() {
          const noteValue = cartNoteField.value;
          
          // Update cart note via AJAX
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: noteValue
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Cart note saved:', noteValue);
          })
          .catch(error => {
            console.error('Error saving cart note:', error);
          });
        }, 1000);
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

